import { render, staticRenderFns } from "./footer-second.vue?vue&type=template&id=3af488eb&"
import script from "./footer-second.vue?vue&type=script&lang=js&"
export * from "./footer-second.vue?vue&type=script&lang=js&"
import style0 from "./footer-second.vue?vue&type=style&index=0&id=3af488eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports